import { useTranslation } from 'react-i18next';
import { Box, Button, TextField } from '@mui/material';

const T = 'organizations.update.wellsFargoWebhook';
const REGISTER_BUTTON_SX = { color: 'common.white' };

const WellsFargoWebhookRegisterForm = ({
  pathKey,
  pathKeyError,
  disabled,
  registering,
  onPathKeyChange,
  onRegister,
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <TextField
        label={t(`${T}.pathKeyLabel`)}
        id='wells_fargo_webhook_path_key'
        name='path_key'
        value={pathKey}
        onChange={(e) => onPathKeyChange(e.target.value)}
        disabled={disabled}
        size='small'
        fullWidth
        error={Boolean(pathKeyError)}
        helperText={pathKeyError || t(`${T}.pathKeyHint`)}
        autoComplete='off'
        sx={{ maxWidth: { md: '50%' } }}
      />
      <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
        <Button
          variant='contained'
          color='primary'
          onClick={onRegister}
          disabled={disabled || pathKey === ''}
          sx={REGISTER_BUTTON_SX}>
          {registering && t(`${T}.registering`)}
          {!registering && t(`${T}.registerButton`)}
        </Button>
      </Box>
    </Box>
  );
};

export default WellsFargoWebhookRegisterForm;
